import { EnglishArabicDTO } from "bbsf-controls"
export class PermissionModel
{
      Id:number
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      OrganizationID :number
      SysName :string
      OrganizationName :EnglishArabicDTO=new EnglishArabicDTO();  
}
     